import {
  POST_FORMECID,
  UPDATE_LICENSE,
  UPDATE_TEXT,
  UPDATE_TOGGLE,
  UPDATE_MESSAGE,
  POST_FORMECID_START,
  POST_FORMECID_SUCCESS,
  POST_FORMECID_ERROR
} from './constants'

const postFormEcid = () => ({ type: POST_FORMECID })
const postFormEcidStart = () => ({ type: POST_FORMECID_START })
const postFormEcidSuccess = () => ({ type: POST_FORMECID_SUCCESS })
const postFormEcidError = (error) => ({ type: POST_FORMECID_ERROR, error })

const updateLicense = (license) => ({ type: UPDATE_LICENSE, license })
const updateText = (text) => ({ type: UPDATE_TEXT, text })
const updateToggle = (toggle )=> ({type: UPDATE_TOGGLE, toggle})
const updateMessage = (hint) => ({type: UPDATE_MESSAGE, hint})

export {
  postFormEcid,
  updateLicense,
  updateText,
  updateToggle,
  updateMessage,
  postFormEcidStart,
  postFormEcidSuccess,
  postFormEcidError
}
